import { NgModule } from '@angular/core';
import { MaterialModule } from '@angular/material';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PageLayoutsRoutingModule } from './page-layouts-routing.module';
import { PageLayoutsComponent } from './page-layouts.component';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { PageLayoutProductReleaseListComponent } from './product-release-list/product-release.component';
import { PageLayoutRevisionComponent} from './revision-changelog/revision.component';
import { PageLayoutUserRightsSummaryComponent} from '../user-management/user-rights-summary/userrightssummary.component';
import { PageLayoutAllChangeLog } from './view-product-changelog/viewallchangelog.component';
import { PageLayoutRevisionHistoryComponent} from './revision-history/revisionhistory.component';
import { PageLayoutProductReleaseComponent} from './add-edit-productrelease/addproductrelease.component';
import {PageLayoutRevertReleaseComponent} from './Revert-Release/revertrelease.component';
import { PageLayoutProductaddComponent} from './add-product/addproduct.component';
import { PageLayoutaddUserComponent} from '../user-management/add-edit-user/adduser.component';
import { PageLayoutUserComponent} from '../user-management/user/user.component';
import {PageLayoutConfirmDialogComponent } from './confirm-dialog/confirmdialog.component';
import { AppLoaderComponent } from '../../services/app-loader/app-loader.component';
import { PageLayoutProductReleaseTabComponent } from './product-release-tab-list/product-release-tab.component';
import { PageLayoutProductReleaseTabListComponent } from './product-list-tab-child-list/product-release-tab-list.component';
import { PageLayoutPushNotificationHistoryComponent } from './push-notification/push-notification-history.component';
import { ActivateReleaseComponent } from './activate-release/activateRelease.component';
import { ChangeReleaseTypeComponent } from './change-release-type/change-release-type.component';
import { SharedModule } from '../shared/shared.module';
@NgModule({
    imports: [
        MaterialModule,
        PageLayoutsRoutingModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,           
        SharedModule,
  //      Ng2FilterPipeModule,    
        [AccordionModule.forRoot()],
    ],
    declarations: [
        PageLayoutsComponent,
        PageLayoutProductReleaseListComponent,
        PageLayoutRevisionComponent,
        PageLayoutProductReleaseComponent,       
        PageLayoutProductReleaseTabListComponent,  
        PageLayoutProductReleaseTabComponent,       
        PageLayoutProductaddComponent,
        PageLayoutPushNotificationHistoryComponent,
        PageLayoutRevertReleaseComponent,
        ActivateReleaseComponent,
        ChangeReleaseTypeComponent,
        PageLayoutRevisionHistoryComponent,
        PageLayoutConfirmDialogComponent,
        AppLoaderComponent,
        PageLayoutAllChangeLog
    ],
    entryComponents: [
        ActivateReleaseComponent,
        ChangeReleaseTypeComponent
    ]
})

export class PageLayoutsModule {}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/page-layouts/page-layouts.module.ts